import Toggle from 'components/UIComponents/Toggle/index'
import {
  EventHeader1,
  PaddedToggleDive,
} from 'modules/RankingAlgorithm/Styles/RankingAlgorithmStyles.js'
import React from 'react'
import DurationIndex from 'modules/RankingAlgorithm/Partials/SkillBucket/Common/Duration/durationIndex.js'
import MandatorySkillIndex from 'modules/RankingAlgorithm/Partials/SkillBucket/Common/Skill/skillIndex.js'
export default function CommonIndex({
  keys,
  singleDurationData,
  academicDataAlone,
  setSingleDurationData,
  setAcademicDataAlone,
  setAcademicValidation,
  academicName,
  current,
  setCurrent,
  durationSwitch,
  setDurationSwitch,
  setDurationToggle,
}) {
  const onClick = target => {
    if (target) {
      setCurrent('right')
    } else {
      setCurrent('left')
    }
  }
  const content = () => {
    return (
      <>
        {current === 'left' || academicName === 'Academic' ? (
          <>
            <MandatorySkillIndex />
          </>
        ) : (
          <>
            <DurationIndex
              keys={keys}
              singleDurationData={singleDurationData}
              setSingleDurationData={setSingleDurationData}
              setAcademicDataAlone={setAcademicDataAlone}
              academicDataAlone={academicDataAlone}
              setAcademicValidation={setAcademicValidation}
              durationSwitch={durationSwitch}
              setDurationSwitch={setDurationSwitch}
              setDurationToggle={setDurationToggle}
            />
          </>
        )}
      </>
    )
  }
  return (
    <div>
      <PaddedToggleDive>
        {academicName === 'Academic' ? (
          <EventHeader1>Skills</EventHeader1>
        ) : (
          <Toggle
            left="Skills"
            right="Duration"
            initialValue={current}
            onClick={e => {
              onClick(e)
            }}
          />
        )}
        {content()}
      </PaddedToggleDive>
    </div>
  )
}
